/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as A from '../../common/actions';
import * as P from './pages';

export const SESSION_LIST     = '/';
export const SESSION_VIEW = '/session/:session/';
export const SESSION_VIEW_SELECTED = '/session/:session/view/:view';

export default {
  [SESSION_LIST]: {
    title: 'Sessions',
    page: P.SESSION_LIST,
    [SESSION_VIEW]: {
      title: 'Session',
      page: P.SESSION_VIEW
    },
    [SESSION_VIEW_SELECTED]: {
      title: 'Session',
      page: P.SESSION_VIEW
    }
  }
};

const sessionListRoveAction = {
  url: SESSION_LIST
};
const sessionViewRoveAction = {
  url: SESSION_VIEW
};
const sessionViewSelectedRoveAction = {
  url: SESSION_VIEW_SELECTED
};

export const ROVER_MAP = {
  [A.NAVIGATE_TO_SESSION_LIST]: sessionListRoveAction,
  [A.NAVIGATE_TO_SESSION_VIEW]: sessionViewRoveAction,
  [A.NAVIGATE_TO_SESSION_VIEW_SELECTED]: sessionViewSelectedRoveAction
};
